<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-subway-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4a2 2 0 011.995 1.85L44 6v31a2 2 0 01-1.85 1.995L42 39h-4.58l3.072 3.66a1 1 0 01-.123 1.41l-1.532 1.285a1 1 0 01-1.41-.123L32.199 39H15.936l-5.229 6.232a1 1 0 01-1.409.123l-1.532-1.286a1 1 0 01-.123-1.409l3.07-3.66H6a2 2 0 01-1.995-1.85L4 37V6a2 2 0 011.85-1.995L6 4h36zm-2 20H8v11h32V24zm-24 3a1 1 0 011 1v2a1 1 0 01-1 1h-3a1 1 0 01-1-1v-2a1 1 0 011-1h3zm19 0a1 1 0 011 1v2a1 1 0 01-1 1h-3a1 1 0 01-1-1v-2a1 1 0 011-1h3zm5-19H8v12h32V8z"/></svg>
</template>
<script>

export default {
  name: 'IconSubwayAlt',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
